<template>
    <v-container grid-list-md text-xs-left>
        <v-layout row wrap>
            <v-flex xs12>
                <h1>AGB</h1><br>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
    }
</script>
